var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 21H25.25V20.25C25.25 20.0511 25.329 19.8603 25.4697 19.7197C25.6103 19.579 25.8011 19.5 26 19.5H28.25C28.4489 19.5 28.6397 19.579 28.7803 19.7197C28.921 19.8603 29 20.0511 29 20.25V21H32V18C32 17.2044 31.6839 16.4413 31.1213 15.8787C30.5587 15.3161 29.7956 15 29 15H20C19.2044 15 18.4413 15.3161 17.8787 15.8787C17.3161 16.4413 17 17.2044 17 18V21H20V20.25C20 20.0511 20.079 19.8603 20.2197 19.7197C20.3603 19.579 20.5511 19.5 20.75 19.5H23C23.1989 19.5 23.3897 19.579 23.5303 19.7197C23.671 19.8603 23.75 20.0511 23.75 20.25V21Z",
    fill: "#32324B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 22.5C16.7554 22.5 15.8016 22.8951 15.0983 23.5983C14.3951 24.3016 14 25.2554 14 26.25V32.25C14 32.4489 14.079 32.6397 14.2197 32.7803C14.3603 32.921 14.5511 33 14.75 33C14.9489 33 15.1397 32.921 15.2803 32.7803C15.421 32.6397 15.5 32.4489 15.5 32.25V28.5H33.5V32.25C33.5 32.4489 33.579 32.6397 33.7197 32.7803C33.8603 32.921 34.0511 33 34.25 33C34.4489 33 34.6397 32.921 34.7803 32.7803C34.921 32.6397 35 32.4489 35 32.25V26.25C35 25.2554 34.6049 24.3016 33.9017 23.5983C33.1984 22.8951 32.2446 22.5 31.25 22.5H17.75Z",
    fill: "#32324B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bed_icon.9491390d32dadf16bd4899737695d5cf.svg";
export { ForwardRef as ReactComponent };